// ═══════════════════════════════════════════════════════════════════════════
// Contraseña: pedirla de nuevo y ponerla
//
// Dos pantallas chicas que faltaban y que dejaron al operador fuera de
// producción con una factura pendiente:
//
//   PedirRecuperacion  desde el acceso, cuando no te acuerdas
//   PonerContrasena    cuando vuelves del correo, o desde Mi cuenta
//
// NO SE DICE SI EL CORREO EXISTE. Contestar "esa cuenta no existe" convierte
// la pantalla en un buscador de quién tiene cuenta: se prueban correos hasta
// dar con uno. Se responde igual siempre.
// ═══════════════════════════════════════════════════════════════════════════

import React, { useState } from "react";
import { pedirRecuperacion, cambiarContrasena, terminarRecuperacion,
         LARGO_MINIMO } from "./sesion.js";
import { LOGO_BASE64 } from "../pdf/logo.js";
import { btnPrimary, inputStyle } from "../ui/estilos.js";

const marco = {
  minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
  background: "#0a0a0a", padding: 16,
};
const caja = {
  width: "100%", maxWidth: 380, background: "#111", border: "1px solid #222",
  borderRadius: 12, padding: 28,
};

export function PedirRecuperacion({ correoInicial, onVolver }) {
  const [email, setEmail] = useState(correoInicial || "");
  const [ocupado, setOcupado] = useState(false);
  const [listo, setListo] = useState(false);
  const [error, setError] = useState("");

  const enviar = async (e) => {
    e.preventDefault();
    setOcupado(true); setError("");
    try {
      await pedirRecuperacion(email);
      setListo(true);
    } catch (err) { setError(err.message); }
    setOcupado(false);
  };

  return (
    <div style={marco}>
      <form onSubmit={enviar} style={caja}>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <img src={LOGO_BASE64} alt="" style={{ width: 56, height: 56, objectFit: "contain" }} />
        </div>

        {listo ? (
          <>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22,
                          color: "#c9d8a0", marginBottom: 10 }}>
              Revisa tu correo
            </div>
            <div style={{ fontSize: 13, color: "#888", lineHeight: 1.8 }}>
              Si <b style={{ color: "#aaa" }}>{email}</b> tiene una cuenta, le llegó un
              enlace para poner una contraseña nueva. Sirve una sola vez y caduca en una
              hora.
              <br /><br />
              <span style={{ color: "#666" }}>
                Si no aparece en unos minutos, mira en la carpeta de correo no deseado.
              </span>
            </div>
          </>
        ) : (
          <>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22,
                          color: "#c9a96e", marginBottom: 6 }}>
              ¿Olvidaste tu contraseña?
            </div>
            <div style={{ fontSize: 13, color: "#888", lineHeight: 1.7, marginBottom: 18 }}>
              Escribe tu correo y te mandamos un enlace para poner una nueva.
            </div>

            <label style={{ fontSize: 11, color: "#666" }}>Correo</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              autoComplete="username" autoCapitalize="none" required autoFocus disabled={ocupado}
              style={{ ...inputStyle, width: "100%", marginBottom: 16 }} />

            {error && (
              <div style={{ background: "#1f0d0d", border: "1px solid #3a1a1a", borderRadius: 6,
                            padding: "10px 12px", marginBottom: 14, fontSize: 12, color: "#e8b0b0" }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={ocupado || !email.trim()}
              style={{ ...btnPrimary, width: "100%", opacity: (ocupado || !email.trim()) ? 0.5 : 1 }}>
              {ocupado ? "Enviando…" : "Mandarme el enlace"}
            </button>
          </>
        )}

        <button type="button" onClick={onVolver}
          style={{ width: "100%", marginTop: 14, padding: "9px", fontSize: 12,
                   background: "transparent", border: "1px solid #222", borderRadius: 6,
                   color: "#888", cursor: "pointer" }}>
          Volver al acceso
        </button>
      </form>
    </div>
  );
}


export function PonerContrasena({ onListo, sesion }) {
  const [uno, setUno] = useState("");
  const [dos, setDos] = useState("");
  const [ocupado, setOcupado] = useState(false);
  const [error, setError] = useState("");

  const corta = uno.length > 0 && uno.length < LARGO_MINIMO;
  const distintas = dos.length > 0 && uno !== dos;
  const puede = uno.length >= 8 && uno === dos;

  const guardar = async (e) => {
    e.preventDefault();
    if (!puede) return;
    setOcupado(true); setError("");
    try {
      await cambiarContrasena(uno);
      terminarRecuperacion();
      onListo?.();
    } catch (err) { setError(err.message); setOcupado(false); }
  };

  return (
    <div style={marco}>
      <form onSubmit={guardar} style={caja}>
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <img src={LOGO_BASE64} alt="" style={{ width: 56, height: 56, objectFit: "contain" }} />
        </div>

        <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22,
                      color: "#c9a96e", marginBottom: 6 }}>
          Pon tu contraseña nueva
        </div>
        <div style={{ fontSize: 13, color: "#888", lineHeight: 1.7, marginBottom: 18 }}>
          {sesion?.user?.email && <>Para <b style={{ color: "#aaa" }}>{sesion.user.email}</b>. </>}
          Al menos {LARGO_MINIMO} caracteres. Anótala donde la vuelvas a encontrar.
        </div>

        {/* Se pide dos veces: teclear mal una contraseña que no se ve deja
            fuera a quien la acaba de poner, y ese es el caso que estamos
            resolviendo. */}
        <label style={{ fontSize: 11, color: "#666" }}>Contraseña nueva</label>
        <input type="password" value={uno} onChange={e => setUno(e.target.value)}
          autoComplete="new-password" required autoFocus disabled={ocupado}
          style={{ ...inputStyle, width: "100%", marginBottom: 4,
                   borderColor: corta ? "#3a1a1a" : undefined }} />
        <div style={{ fontSize: 10, color: corta ? "#c97070" : "#555", marginBottom: 12 }}>
          {corta ? `Van ${uno.length} de ${LARGO_MINIMO} caracteres`
                 : `Mínimo ${LARGO_MINIMO} caracteres`}
        </div>

        <label style={{ fontSize: 11, color: "#666" }}>Otra vez, para confirmar</label>
        <input type="password" value={dos} onChange={e => setDos(e.target.value)}
          autoComplete="new-password" required disabled={ocupado}
          style={{ ...inputStyle, width: "100%", marginBottom: 4,
                   borderColor: distintas ? "#3a1a1a" : undefined }} />
        <div style={{ fontSize: 10, color: distintas ? "#c97070" : "#555", marginBottom: 16 }}>
          {distintas ? "No coinciden" : " "}
        </div>

        {error && (
          <div style={{ background: "#1f0d0d", border: "1px solid #3a1a1a", borderRadius: 6,
                        padding: "10px 12px", marginBottom: 14, fontSize: 12, color: "#e8b0b0" }}>
            {error}
          </div>
        )}

        <button type="submit" disabled={ocupado || !puede}
          style={{ ...btnPrimary, width: "100%", opacity: (ocupado || !puede) ? 0.5 : 1 }}>
          {ocupado ? "Guardando…" : "Guardar y entrar"}
        </button>
      </form>
    </div>
  );
}
